import { each } from 'lodash';
import axios from './axios';

export default {
  list() {
    return axios.get('/uploaded_documents');
  },
  upload(files) {
    const formData = new FormData();
    each(files, (file) => {
      formData.append('files[]', file);
    });
    return axios.post('/upload_document', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
